export default "__VITE_ASSET__BRecbUOP__"